module.exports = __webpack_public_path__ + "media/img/uploads/atak-mil-product-full-02-09fc81a8e8aa862ba2394e50156aaf5a.jpg";